"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _Modal = _interopRequireDefault(require("../../FullScreenModal/Modal"));
var _hooks = _interopRequireDefault(require("../../FullScreenModal/hooks"));
var _theme = _interopRequireDefault(require("../../../theme"));
var _Mobile = _interopRequireDefault(require("../Mobile"));
var _InputRangeDate = _interopRequireDefault(require("../InputRangeDate"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const InputRange = props => {
  const {
    handleDatepicker = () => {}
  } = props;
  const isMd = (0, _useMediaQuery.default)(_theme.default.breakpoints.down('md'));
  const btnOpenModal = (0, _react.useRef)(null);
  const {
    modalProps,
    open: openModal,
    close: closeModal
  } = (0, _hooks.default)({
    background: '#FFF'
  });
  const handleOpenModal = event => {
    if (isMd) {
      openModal(btnOpenModal);
    } else {
      handleDatepicker(event);
    }
  };
  const handleCloseModal = () => {
    closeModal();
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: btnOpenModal
  }, /*#__PURE__*/_react.default.createElement(_InputRangeDate.default, (0, _extends2.default)({}, props, {
    handleDatepicker: handleOpenModal
  }))), /*#__PURE__*/_react.default.createElement(_Modal.default, (0, _extends2.default)({}, modalProps, {
    padding: false,
    closeButton: false
  }), /*#__PURE__*/_react.default.createElement(_Mobile.default, (0, _extends2.default)({}, props, {
    handleCloseModal: handleCloseModal
  }))));
};
var _default = exports.default = InputRange;